export const SET_CLIENTS = (state, clients) => {
    state.clients = clients;
};

export const SET_PROPERTIES = (state, properties) => {
    state.properties = properties;
};

export const SET_WAREHOUSES = (state, warehouses) => {
    state.warehouses = warehouses;
};

export const SET_REPORT_LIST = (state, reportList) => {
    state.reportList = {
        ...reportList,
        page: reportList.page + 1
    };
};

export const SET_CULTIVATIONS = (state, cultivations) => {
    state.cultivation_types = cultivations;
};

export const SET_SAFRAS = (state, cultivations) => {
    state.safras = cultivations;
};

export const SET_DEPARTMENTS = (state, deliveryLocations) => {
    state.departments = deliveryLocations;
};

export const SET_DISTRICTS = (state, districts) => {
    state.districts = districts;
};

export const RESET_FORM = state => {
    state.form = {
        contract_data: {
            contract_number: '',
            volume: undefined,
            cultivation_id: 'SOJA',
            safra: '',
            warehouse_id: '',
            department: '',
            delivery_location_id: '',
            client_id: '',
            contract_date: ''
        },
        protocol_id: undefined,
        properties: []
    };
};

export const SET_SUMMARY = (state, summary) => {
    state.summary = {
        contracts_total: summary.totalContracts,
        volume_total: summary.totalVolume,
        properties_total: summary.totalTerritories,
        contracts_reproved_total: summary.totalReprovedContracts,
        total_waiting_contracts: summary.totalWaitingContracts
    };
};

export const SET_AVAILABLE_BALANCE = (state, availableBalance) => {
    state.availableBalance = {
        territory_id: availableBalance.territory_id,
        ton: availableBalance.ton,
        sc: availableBalance.sc,
        valid: availableBalance.valid
    };
};

export const SET_FILES = (state, files) => {
    if (files.lenght > 0) {
        files.forEach(file => {
            state.files.push({
                    id: file.id,
                    blobReference: file.blobReference,
                    type: file.type,
                    createdAt: file.createdAt,
                    active: file.active
            });
        });
    } else {
        state.files = [];
    }

};

export const SET_FILTER = (state, filter) => {
    state.filter = {
        page: filter.page ?? state.filter.page,
        size: filter.size ?? state.filter.size,
        contract_number: filter.contract_number ?? state.filter.contract_number,
        status: filter.status ?? state.filter.status ?? [],
        client: filter.client ?? state.filter.client,
        safra: filter.safra ?? state.filter.safra,
        cultivations: filter.cultivations ?? state.filter.cultivations
    };
};

export const CLEAR_FILTER = state => {
    state.filter = {
        page: 0,
        size: 10,
        contract_number: '',
        status: [],
        client: '',
        safra: '',
        cultivations: [],
        loading: false
    };
};

export const SET_FORM = (state, data) => {
    state.form = data;
};

export const SET_REPORT = (state, data) => {
    state.report = data;
};
